export default "__VITE_ASSET__Dgx0Y7MA__"